import axios from "axios";

import { convertJsonToFormData } from "../tools/tools";


// local
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

/**
 * Global request function for handling all HTTP calls
 * @param method
 * @param url
 * @param options {params: <for query params>, payload: <for data to be sent>'}
 */

const request = (method, url, options = { params: {}, payload: {} }) => {
  const request = {
    url,
    method,
    params: options.params,
    data: options.payload
  };
  return new Promise((resolve, reject) => {
    if (method !== "GET") {

      //   History.dispatchInstance(showLoader());
    }
    axios.request(request).then((res) => {
      resolve(res);
      if (method !== "GET") {

        // hide loader
      }
    }).catch((err) => {
      console.error('[API] request failed:', {
        method: request.method,
        url: request.url,
        params: request.params,
        message: err?.message,
        status: err?.response?.status,
        data: err?.response?.data
      });
      reject(err);
    });
  });
};


export const POST = (path, payload) => {
  return request("POST", path, { payload: payload });
};

export const Upload = (path, payload) => {
  return request("POST", path, { payload: convertJsonToFormData(payload) });
};

export const GET = (path, params) => {
  return request("GET", path, { params });
};

export const GETALL = (path, filters) => {
  return request("GET", path, { params: filters });
};

export const PUT = (path, payload) => {
  return request("PUT", path, { payload: payload });
};

export const PATCH = (path, payload) => {
  return request("PATCH", path, { payload: payload });
};

export const DELETE = (path) => {
  return request("DELETE", path);
};

axios.interceptors.request.use((request) => {
  // Setting up headers
  const token = sessionStorage.getItem('token');
  let headers = {};
  if (token) {
    headers["authorization"] = `${token}`;
  }

  // Don't override Content-Type for FormData - let Axios set it automatically
  if (request.data instanceof FormData) {

    // Axios will automatically set Content-Type to multipart/form-data with boundary
  }
  request.headers = { ...request.headers, ...headers };
  return request;
});


/**
 * RESPONSE INTERCEPTOR
 * Success: return backend body as-is { success, statusCode, message, data }.
 * Callers receive this body directly (not axios response), so use res.success, res.data, res.message.
 * Error: reject with { success: false, message, error: { message }, error_msg } matching backend shape.
 */
axios.interceptors.response.use(
  (response) => {
    try {
      if (!response || typeof response !== 'object') {
        console.warn('[API] success with no response object');
        return { success: true, statusCode: 200, message: '', data: null };
      }
      const body = response.data;
      return body !== null && typeof body === 'object' ? body : { success: true, statusCode: 200, message: '', data: null };
    } catch (e) {
      console.warn('[API] response handler error:', e && e.message);
      return { success: true, data: null };
    }
  },
  (error) => {
    try {
      const res = error && typeof error === 'object' && error.response;
      const data = res && typeof res === 'object' && res.data;
      const requestUrl = error?.config?.url || '';
      const status = res && res.status;
      const message =
      data && typeof data === 'object' && data.message ? String(data.message) :
      data && typeof data === 'object' && data.error && data.error.message ? String(data.error.message) :
      data && typeof data === 'object' && data.data && typeof data.data === 'object' && data.data.error_msg ? String(data.data.error_msg) :
      data && typeof data === 'object' && data.error_msg ? String(data.error_msg) :
      error && error.message ? String(error.message) :
      'Network or server error. Please try again.';
      const errPayload = {
        success: false,
        statusCode: (data && typeof data === 'object' && data.statusCode) ?? status,
        message,
        error: { message },
        error_msg: message,
        response: res,
        code: error && error.code
      };
      console.error('[API] response error:', {
        url: requestUrl,
        status,
        code: error && error.code,
        message,
        data
      });
      return Promise.reject(errPayload);
    } catch (e) {
      const fallback = { success: false, message: 'Request failed', error_msg: 'Request failed', error: { message: 'Request failed' } };
      console.warn('[API] error handler failed:', e && e.message);
      return Promise.reject(fallback);
    }
  }
);